// TODO: refactor me
export const GTM_ID_8847 = import.meta.env.VITE_GTM_ID_8847 ?? '';
export const GTM_ID_1903 = import.meta.env.VITE_GTM_ID_1903 ?? '';
export const GTM_ID_5292 = import.meta.env.VITE_GTM_ID_5292 ?? '';
export const GTM_ID_2592 = import.meta.env.VITE_GTM_ID_2592 ?? '';

export const ENVIRONMENT = import.meta.env.VITE_ENV ?? 'development';
export const COOKIE_NAME_USAGE_CONSENT = import.meta.env.VITE_COOKIE_NAME_USAGE_CONSENT ?? 'cookie_control_consent';
export const COOKIE_CONSENT_EXPIRES_DAYS = parseInt(import.meta.env.VITE_COOKIE_CONSENT_EXPIRES_DAYS ?? '365', 10);